import "./GetAQuote.module.css";
import Header from "@/reusable_sections/Header";
import Estimate from "./sections/Estimate";
import Territory from "./sections/Territory";
import Footer from "@/reusable_sections/Footer";
export default function GetAQuotePage() {
  return <div>
      <Header />
      <Estimate />
      <Territory />
      <Footer />
    </div>;
}